// import { Product } from 'pages/Product';
import Client from '../Client.provider';
import {
  iExhibitorListRest,
  iRest,
  iFormExhibitor,
  iExhibitorRest,
  iExhibitorListExhibitors,
  ExhibitorRest,
  IEventExhibitorRest,
} from './Exhibitor.type';

import { iProductExtractRest } from 'services/Product/Product.type';

interface ivExhibitorRest {
  id: number;
  nom_societe: string;
  email_societe: string;
  site_web: string;
  twitter: string;
  instagram: string;
  linkedin: string;
  facebook: string;
  hall: string;
  stand: string;
  raison_sociale: string;
  showroom: number;

  adresse_postale: string;
  code_postal: string;
  ville: string;
  pays: string;
  tel_societe: string;
  type_entreprise: string;
  taille_domaine: string;
  production_annuelle: string;
  pourcentage_export: string;
  pays_export: string;
  pays_import: string;
  description_en: string;

  contact_revendeur_firstname: string;
  contact_revendeur_lastname: string;
  contact_revendeur_port: string;
  contact_revendeur_tel: string;
  contact_revendeur_email: string;

  logo_uuid: string;
  logo_extension: string;

  media_1_uuid: string;
  media_1_extension: string;

  media_2_uuid: string;
  media_2_extension: string;

  media_3_uuid: string;
  media_3_extension: string;

  media_4_uuid: string;
  media_4_extension: string;

  media_5_uuid: string;
  media_5_extension: string;
  youtube_video: string;
}

type ExhibitorRestParams = any;

export interface EventExhibitorFilter {
  name: string;
  topic: string;
  options: Array<{ value: string; label: string }>;
}

export interface Ext {
  exhibitor: iExhibitorRest & { logo_url: string };
  products: Array<iProductExtractRest | null>;
}
export interface iExhibitorRepository {
  getExhibitors: (eventId: string) => Promise<iExhibitorListRest[]>;
  findById: (id: any) => Promise<ivExhibitorRest>;
  findEventExhibitorById: (
    slug: string,
    id: string | number
  ) => Promise<ivExhibitorRest>;
  getExhibitorsWithoutEvent: () => Promise<iExhibitorListRest[]>;
  getExhibitorsList: (
    eventId: string | undefined,
    filter: any
  ) => Promise<iExhibitorListExhibitors[]>;
  getUserExhibitor: (idExhibitor?: string) => Promise<iRest>;
  extractUserExhibitor: (idExhibitor?: string) => Promise<Ext>;
  updateUserExhibitor: (
    form: iFormExhibitor,
    exhibitorId: number
  ) => Promise<iRest>;
  mergeUserExhibitor: (
    type: any,
    value: any,
    exhibitorId: number,
    eventId: string | undefined
  ) => Promise<boolean>;
  lockAllExhibitors: (locked: boolean) => Promise<boolean>;
  visibleAllExhibitors: (visible: boolean) => Promise<boolean>;
  uploadCSV: (form: FormData) => Promise<any>;
  uploadExhiCSV: (form: FormData) => Promise<any>;
  downloadCSV: (eventId: string | undefined) => Promise<any>;
  downloadPdf: (
    eventId: string | undefined,
    exhibitorId: string | undefined
  ) => Promise<any>;
  removeInvite: (
    exhibitorId: string | number | undefined,
    eventId: string | number | undefined
  ) => Promise<any>;
  getExhibitorEvents: () => Promise<any>;
  getEventExhibitors: (eventId: string | number) => Promise<any>;
  importExhibitorsExcel: (
    eventId: string | number | undefined,
    form: FormData
  ) => Promise<any>;
  searchBySlug: (
    slug: string,
    params: ExhibitorRestParams
  ) => Promise<IEventExhibitorRest>;
  products: (slug: string, id: string) => Promise<any>;
  eventProducts: (slug: string) => Promise<any>;
  eventShowroomProducts: (eventId: string | number) => Promise<any>;
  exportDocumentPdf: (
    eventId: string | number,
    name?: string,
    whiteSpace?: boolean,
    documentId?: string | number
  ) => Promise<any>;
}

const BASE_PATH = window.location.pathname.split('/')[1];

export class ExhibitorRepository
  extends Client
  implements iExhibitorRepository
{
  public async getExhibitors(eventId: string): Promise<iExhibitorListRest[]> {
    return await this.restricted()
      .get<iExhibitorListRest[]>(`/user/exhibitors/${eventId}`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getExhibitorsWithoutEvent(): Promise<iExhibitorListRest[]> {
    return await this.restricted()
      .get<iExhibitorListRest[]>(`/user/exhibitors_list`)
      .then((e) => e.data);
  }

  public async getExhibitorsList(
    eventId: string | undefined,
    filter: any
  ): Promise<iExhibitorListExhibitors[]> {
    const query: string[] = [];
    query.push(`reload=${filter.reload}`);
    if (filter.couleur) {
      query.push(`color_wine=${filter.couleur}`);
    }
    if (filter.type_cepage) {
      query.push(`grape_veriety=${filter.type_cepage}`);
    }
    if (filter.type_culture) {
      query.push(`type_of_wine_growing=${filter.type_culture}`);
    }
    if (filter.type_product) {
      query.push(`type_of_product=${filter.type_product}`);
    }
    if (filter.search) {
      query.push(`search=${filter.search}`);
    }
    const resultQuery: string = '?' + query.join('&');
    return await this.restricted()
      .get<iExhibitorListExhibitors[]>(
        `/user/exhibitors_list/${
          eventId !== undefined ? eventId : 0
        }${resultQuery}`
      )
      .then((e) => e.data);
  }

  public async getUserExhibitor(idExhibitor: string = ''): Promise<iRest> {
    return await this.restricted()
      .get<iRest>(`/user/exhibitor${idExhibitor ? `/${idExhibitor}` : ''}`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async extractUserExhibitor(idExhibitor: string = ''): Promise<Ext> {
    return await this.restricted()
      .get<{
        exhibitor: iExhibitorRest & { logo_url: string };
        products: Array<iProductExtractRest | null>;
      }>(`/user/exhibitor/extract${idExhibitor ? `/${idExhibitor}` : ''}`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async updateUserExhibitor(
    form: iFormExhibitor,
    exhibitorId: number
  ): Promise<iRest> {
    return await this.restricted()
      .put<iRest>(`/user/exhibitor/${exhibitorId}`, form)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async mergeUserExhibitor(
    type: string,
    value: any,
    exhibitorId: number,
    eventId: string | undefined
  ): Promise<boolean> {
    return await this.restricted()
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      .put<iRest>(`/user/exhibitor/merge/${exhibitorId}/${eventId}`, {
        [type]: value,
      })
      .then((e) => !e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async lockAllExhibitors(locked: boolean): Promise<boolean> {
    return await this.restricted()
      .put<iRest>(`/user/exhibitors/lock`, {
        locked,
      })
      .then((e) => !!e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async visibleAllExhibitors(visibility: boolean): Promise<boolean> {
    return await this.restricted()
      .put<iRest>(`/user/exhibitors/visibility`, {
        visibility,
      })
      .then((e) => !!e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async uploadCSV(form: FormData): Promise<any> {
    return await this.restricted()
      .post<any>(`/exhibitor/update/import`, form)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async uploadExhiCSV(form: FormData): Promise<any> {
    return await this.restricted()
      .post<any>(`/user/import`, form)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async downloadCSV(eventId: string | undefined): Promise<any> {
    return await this.restricted()
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      .get<any>(`get-csv-file/${eventId}`)
      .then((e) => e)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async downloadPdf(
    eventId: string | undefined,
    exhibitorId: string | undefined
  ): Promise<any> {
    try {
      const response = await this.restricted().get(
        `get-pdf-file/${eventId ?? 0}`,
        {
          responseType: 'blob',
          params: {
            exhibitor_id: exhibitorId,
          },
        }
      );

      return response;
    } catch (error: any) {
      if (error.response && error.response.data instanceof Blob) {
        const text = await error.response.data.text();
        const json = JSON.parse(text);

        throw new Error(json.message);
      }

      throw new Error(
        error.response?.data?.message ||
          `${error.response?.status} | Unknown error`
      );
    }
  }

  public async removeInvite(
    exhibitorId: string | number | undefined,
    eventId: string | number | undefined
  ): Promise<any> {
    return await this.restricted()
      .delete<any>(
        `remove-invite/${exhibitorId !== undefined ? exhibitorId : 0}/${
          eventId !== undefined ? eventId : 0
        }`
      )
      .then((e) => e)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getExhibitorEvents(): Promise<any> {
    return await this.restricted()
      .get<any>(`${BASE_PATH}/exhibitors/events`)
      .then((e) => e)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async getEventExhibitors(eventId: string | number): Promise<any> {
    return await this.restricted()
      .get<any>(`${BASE_PATH}/events/${eventId}/exhibitors`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async importExhibitorsExcel(
    eventId: string | number | undefined,
    form: FormData
  ): Promise<any> {
    return await this.restricted()
      .post<any>(
        `${BASE_PATH}/event/${
          eventId !== undefined ? eventId : 0
        }/exhibitor-invite/import/excel`,
        form
      )
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            JSON.stringify(error.response.data)
              .replace(/[{}[\]"]/g, '')
              .replace(/,/g, '<br/>') ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async findById(id: any): Promise<ivExhibitorRest> {
    return await this.public()
      .get<ivExhibitorRest>(`/frenchpavilionbybusinessfrance/exhibitors/${id}`)
      .then((e) => e.data);
  }

  public async searchBySlug(
    slug: string,
    params: ExhibitorRestParams
  ): Promise<IEventExhibitorRest> {
    // Forward every non-empty param (page, per_page, search and any dynamic filter)
    const query = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        query.append(key, String(value));
      }
    });
    const resultQuery: string = '?' + query.toString();
    return await this.public()
      .get<IEventExhibitorRest>(
        // 'https://api.vinsdeloire.exhibitorsmanager.com/frenchpavilionbybusinessfrance.com/exhibitors/search'
        BASE_PATH + `/events/${slug}/exhibitors${resultQuery}`
      )
      .then((e) => e.data);
  }

  /** Filter groups (and their options) available for the exhibitors of an event. */
  public async getFiltersBySlug(
    slug: string,
    locale?: string
  ): Promise<EventExhibitorFilter[]> {
    return await this.public()
      .get<{ filters: EventExhibitorFilter[] }>(
        BASE_PATH +
          `/events/${slug}/exhibitors/filters?locale=${locale ?? 'en'}`
      )
      .then((e) => e.data.filters ?? []);
  }

  public async findEventExhibitorById(
    slug: string,
    id: string | number
  ): Promise<ivExhibitorRest> {
    return await this.public()
      .get<ivExhibitorRest>(BASE_PATH + `/events/${slug}/exhibitors/${id}`)
      // .get(
      //   'https://api.vinsdeloire.exhibitorsmanager.com/frenchpavilionbybusinessfrance.com/exhibitors/646'
      // )
      .then((e) => e.data);
  }

  public async products(slug: string, id: string): Promise<any> {
    return await this.public()
      .get<any>(BASE_PATH + `/events/${slug}/exhibitors/${id}/products`)
      // .get(
      //   'https://api.vinsdeloire.exhibitorsmanager.com/frenchpavilionbybusinessfrance.com/exhibitors/646/products'
      // )
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  public async eventProducts(slug: string): Promise<any> {
    return await this.public()
      .get<any>(BASE_PATH + `/events/${slug}/products`)
      .then((e) => e.data)
      .catch((error) => {
        throw new Error(
          error.response.data.message ||
            `${error.response.status} | Unknow error...`
        );
      });
  }

  // public async eventShowroomProducts(eventId: string | number): Promise<any> {
  //   return await this.restricted()
  //     .get<any>(BASE_PATH + `/events/${eventId}/showroom-products`)
  //     .then((e) => e.data)
  //     .catch((error) => {
  //       throw new Error(
  //         error.response.data.message ||
  //           `${error.response.status} | Unknow error...`
  //       );
  //     });
  // }

  public async eventShowroomProducts(eventId: string | number): Promise<any> {
    try {
      const response = await this.restricted().get(
        `${BASE_PATH}/events/${eventId ?? 0}/showroom-products`,
        {
          responseType: 'blob',
        }
      );

      return response;
    } catch (error: any) {
      if (error.response && error.response.data instanceof Blob) {
        const text = await error.response.data.text();
        const json = JSON.parse(text);

        throw new Error(json.message);
      }

      throw new Error(
        error.response?.data?.message ||
          `${error.response?.status} | Unknown error`
      );
    }
  }

  public async exportDocumentPdf(
    eventId: string | number,
    name?: string,
    whiteSpace = true,
    documentId?: string | number
  ): Promise<any> {
    try {
      const response = await this.restricted().get(
        `${BASE_PATH}/events/${eventId ?? 0}/document-pdf`,
        {
          responseType: 'blob',
          params: {
            ...(name ? { name } : {}),
            ...(documentId ? { document_id: documentId } : {}),
            whiteSpace,
          },
        }
      );

      return response;
    } catch (error: any) {
      if (error.response && error.response.data instanceof Blob) {
        const text = await error.response.data.text();
        const json = JSON.parse(text);

        throw new Error(json.message);
      }

      throw new Error(
        error.response?.data?.message ||
          `${error.response?.status} | Unknown error`
      );
    }
  }
}
